exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tab-container[data-v-f9a2543c]{margin:0;height:100vh}.flex[data-v-f9a2543c]{display:-moz-flex;display:-ms-flex;display:-o-flex;display:-webkit-box;display:-ms-flexbox;display:flex}.block-container[data-v-f9a2543c]{height:calc(100vh - 50px);padding:20px;width:100%;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-flow:column nowrap;flex-flow:column nowrap}.edit-field[data-v-f9a2543c]{padding:20px;background:#fefefe}.label[data-v-f9a2543c]{width:50px!important}h1[data-v-f9a2543c]{font-weight:700;font-size:1em}.blank[data-v-f9a2543c]{width:10vw}.add-box[data-v-f9a2543c]{margin-top:15px;width:65vw;height:auto;padding:20px;line-height:13px;border:thin solid #ccc}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f9a2543c","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/DashBoard/Setting/PersonalSetting.vue
// module id = zGer
// module chunks = 3